// ** Modules
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
	text: string;
};

const Translations = ({ text }: Props) => {
	// Hook
	const { t } = useTranslation();

	return <React.Fragment>{`${t(text)}`}</React.Fragment>;
};

export default Translations;
